<template>
  <div>
    <GlobalTable
      :title="title+' List'"
      :fields="fields"
      :items="items"
      :editButton="true"
      :redirectDetail="false"
      :isLoading="isLoading"
      @addForm="addForm"
      @editForm="editForm"
    ></GlobalTable>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{title}}</h6>
      </template>

      <CForm>
          <CRow>
            <CCol sm="9">
              <label for="nik">Description</label>
              <quill-editor style="height: 200px; margin-bottom:70px;"
                :content="content"
                :options="editorOption"
                v-model="$v.termConditionForm.description.$model"
                @change="onEditorChange($event)">
              </quill-editor>
              <div v-if="$v.termConditionForm.description.$invalid" class="invalid-feedback-custom">
                Description harus di isi.
              </div>
              <!-- <CTextarea
                rows="4"
                label="Description"
                invalid-feedback="Description should be filled"
                required
                v-model="$v.termConditionForm.description.$model"
                :is-valid="!$v.termConditionForm.description.$invalid"
              /> -->
            </CCol>
          </CRow>
      </CForm>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.termConditionForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import GlobalTable from "../../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'

export default {
  name: "terms_and_condition",
  components: { GlobalTable, quillEditor },
  data() {
    return {
      title: "Terms and Condition",
      productList: [],
      issueList: [],
      userList: [],
      fields: [
        { key: "description", label: "Description", sorter: true },
        { key: "action", _classes: "text-center action" }
      ],
      items: [],
      termConditionForm: tableInterfaces.terms_and_condition,
      isLoading: false,
      addButton: false,
      isEdit: false,
      content: '',editorOption: {},	// data quill
    };
  },
  validations: {
    termConditionForm: {
      description: { required },
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function() {
      this.isEdit = false;
      this.cancelForm();
      this.getFaq();
    },
    getFaq: function() {
      this.isLoading = true;
      this.axios.get("console/master/term_condition/listing").then(response => {
        if (response.data.status === 2000) {
          this.items = response.data.data;
          this.showInfoNotification({
            title: this.title,
            message: response.data.message
          });
        } else {
          this.showErrorNotification({
            title: this.title,
            message: response.data.message
          });
        }
      })
      .catch(error => {
        this.showErrorNotification({
          title: this.title,
          message: error
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
    addForm: function() {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function() {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function(item) {
      this.addForm();
      this.isEdit = true;
      this.termConditionForm = item;
    },
    resetForm: function() {
      for (var i in tableInterfaces.terms_and_condition) {
        tableInterfaces.terms_and_condition[i] = null;
      }
      this.termConditionForm = tableInterfaces.terms_and_condition;
    },
    submitForm: function(event) {
      event.preventDefault();
      if (this.isEdit === false) {
        if (confirm("Do you want to add this data ?")) {
          let path = this.$route.path.split("/");
          this.isLoading = true;
          this.axios.post("console/master/term_condition/add", this.termConditionForm).then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message
              });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message
              });
            }
          }).catch(error => {
            this.showErrorNotification({
              title: this.title,
              message: error
            });
          }).finally(() => {
            this.isLoading = false;
            this.init();
          });
        }
      }else{
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios.put("console/master/term_condition/update", this.termConditionForm).then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          }).catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          }).finally(() => {
            this.isLoading = false;
            this.init();
          });
        }
      }
    },
    onEditorChange({ quill, html, text }) {
      this.content = html
      this.termConditionForm.description = html
    },
  },
  mounted() {
    this.init();
  }
};
</script>
